import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Lock orientation to portrait on supported platforms
try {
  (screen.orientation as any).lock?.("portrait")?.catch?.(() => {});
} catch (_) {}

createRoot(document.getElementById("root")!).render(<App />);
